import React, { useMemo } from 'react'

import { TokenResult } from '@ambire-common/libs/portfolio'
import Button, { Props } from '@common/components/Button'
import Text from '@common/components/Text'
import useTheme from '@common/hooks/useTheme'

import BaseTokenItem from './BaseTokenItem'
import { TokenRowContextProps } from './TokenItem'

export interface ClaimButtonProps extends Omit<Props, 'type'> {}

const ClaimButton = ({ textStyle, ...rest }: ClaimButtonProps) => {
  const { theme } = useTheme()

  const claimStyles = useMemo(
    () => ({
      container: {
        backgroundColor: `${String(theme.projectedRewards)}10`,
        borderColor: theme.projectedRewards,
        borderWidth: 1
      },
      text: {
        color: theme.projectedRewards
      }
    }),
    [theme]
  )

  return (
    <Button
      {...rest}
      type="secondary"
      style={[claimStyles.container]}
      textStyle={[claimStyles.text, textStyle]}
    />
  )
}

const RewardsTokenItem = ({
  token,
  networks,
  simulatedAccountOp,
  balanceHidden,
  onPress,
  actionButtonText,
  description
}: {
  token: TokenResult
  onPress?: () => void
  actionButtonText?: string
  description: string | React.ReactNode
} & TokenRowContextProps) => {
  return (
    <BaseTokenItem
      rewardsStyle
      token={token}
      networks={networks}
      simulatedAccountOp={simulatedAccountOp}
      balanceHidden={balanceHidden}
      onPress={onPress}
      decimalRulesType="noDecimal"
      hasBottomSpacing
      extraActions={
        onPress &&
        actionButtonText && (
          <ClaimButton
            size="small"
            hasBottomSpacing={false}
            onPress={onPress}
            text={actionButtonText}
          />
        )
      }
      label={
        <Text fontSize={12} weight="regular">
          {description}
        </Text>
      }
      borderRadius={16}
      wrapperTestID="projected-rewards-asset-button"
    />
  )
}

export default React.memo(RewardsTokenItem)
